import { backend, domain } from 'modules/data';
import { RequestEditMode } from 'pages/requestForm/selectors/requestSelectors';
import { PropsWithChildren } from 'react';

export interface XeroBillBatchPaymentBaseProps {
    request: domain.XeroBillBatchPaymentRequest;
}

export interface XeroBillBatchPaymentFormProps {
    request: domain.XeroBillBatchPaymentRequest;
}

export enum SortingDirection {
    Ascending = 'Ascending',
    Descending = 'Descending',
}

export interface FilterTrasferData extends Omit<backend.transfers.BillRequestsForBatchPaymentTransfer, 'companyId'> {}

export interface XeroBillBatchPaymentRequestContextType {
    billBatchPayment: domain.XeroBillBatchPayment;
    setBillBatchPayment: (
        newBillBatchPayment: domain.XeroBillBatchPayment,
        propName: keyof domain.XeroBillBatchPayment
    ) => void;
    showErrors: boolean;
    setShowErrors: (newValue: boolean) => void;
    saveAndSubmit: (commentText: string) => void;
    clearItems: () => void;
    addBills: (selectableBills: domain.XeroBatchSelectableBillItem[]) => void;

    removeSelectableBillById: (xeroBillInvoiceRequestId: string) => void;
    changeBillInvoiceItemField: (
        xeroBillInvoiceRequestId: string,
        itemField: keyof domain.PaymentItem,
        newValue: domain.PaymentItem[keyof domain.PaymentItem]
    ) => void;
    billInvoiceRequestIdsWithError: string[];
    billInvoiceRequestIdsWithExceededAmount: string[];
    updateBillBatchPayment: (billBatchPayment: domain.XeroBillBatchPaymentDetails) => void;
    isSaving: boolean;
    companyId: string;
    integrationCountryCode: backend.OrganisationVersion;
    editMode: RequestEditMode;
    removeLinesDisabled: boolean;
}

export interface XeroBillBatchPaymentRequestContextProviderProps extends PropsWithChildren {
    request: domain.XeroBillBatchPaymentRequest;
    editRequestField: <TDetails, TKey extends keyof TDetails = keyof TDetails>(
        propName: TKey,
        newValue: TDetails[TKey]
    ) => void;
}

export interface UseBillsForBatchPaymentData {
    companyId: string;
    filterTransfer: FilterTrasferData;
    integrationCountryCode: backend.OrganisationVersion;
    enabled?: boolean;
}
